module.exports = __webpack_public_path__ + "img/png_title_cuoshi.3fe88192.png";